import RauliButtonLink from "@app/components/RauliButtonLink";
import commonStorage from "@app/storage/Common";
import CloseIcon from "@mui/icons-material/Close";
import RefreshIcon from "@mui/icons-material/Refresh";
import UpdateIcon from "@mui/icons-material/Update";
import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const UpdateModal = observer(() => {
  const { t } = useTranslation();
  const { updateAvailable, setUpdateState } = commonStorage;
  const [open, setOpen] = useState(true);

  if (updateAvailable === "no-update") {
    return null;
  }

  let text = t("Update is available!");
  switch (updateAvailable) {
    case "update-in-progress":
      text = t("Update in progress!");
      break;
    case "update-approved":
      text = t("Update finished, reloading...");
      break;
    default:
      break;
  }

  return (
    <Dialog open={open} disableEscapeKeyDown maxWidth="sm" fullWidth>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "200px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <IconButton
          onClick={() => setOpen(false)}
          sx={{ position: "absolute", top: 0, right: 0 }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6">{text}</Typography>
        <Typography>{t("A new version of the app is available!")} </Typography>
        <Typography>
          {t("An update is required to continue using the app.")}
        </Typography>
        <DialogActions sx={{ paddingTop: 4 }}>
          {updateAvailable === "update-available" ? (
            <RauliButtonLink
              onClick={() => setUpdateState("update-approved")}
              text={t("Update")}
              mobileText={t("Update")}
              title={t("Update")}
              capitalized
              icon={<UpdateIcon />}
            />
          ) : (
            <RauliButtonLink
              onClick={() => window.location.reload()}
              text={t("Reload to continue")}
              mobileText={t("Reload to continue")}
              title={t("Reload to continue")}
              capitalized
              icon={<RefreshIcon />}
            />
          )}
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
});

export default UpdateModal;
